module.exports = __webpack_public_path__ + "static/media/try.f625a017.svg";